/* eslint-disable react/jsx-key */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useState, useEffect, useContext, useMemo } from 'react'
import { strCol, numCol, dateCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  modifierCol,
  modifiedDateCol,
  YNBooleanTypes,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo, getEnvConfig, getPermitActions } from 'core'
import { connect } from 'react-redux'

import {
  getPiTags,
  getPiTagTypes,
  savePiTag,
  deletePiTag,
  getWindUtilitySelection,
} from 'api/pgads.js'
import { hasAccesPermits } from 'core/utils'
import CommonScreen from './../admin/component/CommonScreen'
import { Select, Button, InputNumber, DatePicker, Input } from 'antd'
import { ErrorContext } from 'context'
import * as ScreenPermissions from 'core/EventActions'
import R from 'ramda'
const modifyTask = apiTargetInfo => data => savePiTag(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data => deletePiTag(apiTargetInfo)(data)

const header = [
  dateCol({
    ident: 'effectieveDate',
    display: 'Effective Date',
    width: 100,
    isFiltered: true,
    isKey: true,
  }),
  strCol({
    ident: 'piTag',
    display: 'PI Tag',
    width: 260,
    isFiltered: true,
    isKey: true,
  }),
  strCol({
    ident: 'isActive',
    display: 'Is Active',
    isRequired: true,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'tagType',
    display: 'Type',
    // ...toSelectionColProps(tagtypes),
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'utility',
    display: 'Plant',
    isRequired: true,
    // dataGetter: this.unitGetterForUpdate,
    width: 200,
  }),
  strCol({
    ident: 'subgroup',
    display: 'Sub Group',
    isRequired: true,
    // dataGetter: this.unitGetterForUpdate,
    // ...toSelectionColProps(this.state.windPlantSubgroup),
    width: 200,
  }),
  numCol({ ident: 'multiplier', display: 'Multiplier' }),
  modifierCol,
  modifiedDateCol,
]

const title = 'PI Tag'

const PITag = ({ apiTargetInfo, envConfig, actionPermits }) => {
  const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  const [tagType, setTagType] = useState([])
  // const [windUtility, setWindUtility] = useState({})
  const [windUtilityName, setWindUtilityName] = useState({})
  // const [windSubgroup, setWindSubgroup] = useState({})
  // const [windSubgroupName, setWindSubgroupName] = useState({})
  // const [windUtilitySubgroup, setWindUtilitySubgroup] = useState({})

  const hasPITagWriteAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.PI_WRITE_TAG_MANAGEMENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  useEffect(
    _ => {
      const ob = ob =>
        R.compose(
          R.reduce((a, b) => ({ ...a, ...b }), {}),
          R.map(d => ({ [d]: d }))
        )(ob)
      // ob.map(t => ({ [t]: t })).reduce((a, b) => ({ ...a, ...b }))
      getPiTagTypes(apiTargetInfo).fork(setError, tagType => {
        const tt = ob(tagType.split(','))
        setTagType(tt)
      })
      getWindUtilitySelection(apiTargetInfo).fork(setError, data => {
        // setWindUtility(ob(data.map(d => d.utility)))
        // const unm = data
        //   .map(d => ({ [d.utility]: d.utilityName }))
        //   .reduce((a, b) => ({ ...a, ...b }))
        const unm = R.compose(
          R.reduce((a, b) => ({ ...a, ...b }), {}),
          R.map(d => ({ [d.utility]: d.utilityName }))
        )(data)
        setWindUtilityName(unm)
        // const sgd = ob(data.map(d => d.subgroupId))
        // setWindSubgroup(sgd)
        // const snm = data
        //   .map(d => ({ [d.subgroupId]: d.subgroupName }))
        //   .reduce((a, b) => ({ ...a, ...b }))
        // setWindSubgroupName(snm)

        // const usm = R.compose(
        //   R.reduce((a, b) => ({ ...a, ...b }), {}),
        //   R.map(([k, v]) => ({ [k]: v.map(s => s.subgroupId) })),
        //   R.toPairs,
        //   R.groupBy(s => s.utility)
        // )(data)
        // setWindUtilitySubgroup(usm)
      })
    },
    [apiTargetInfo, setError]
  )

  const headerformatter = useMemo(
    _ =>
      header.map(h =>
        h.ident === 'tagType'
          ? {
              ...h,
              ...toSelectionColProps(tagType),
            }
          : h.ident === 'utility'
          ? {
              ...h,
              ...toSelectionColProps(windUtilityName),
            }
          : // : h.ident === 'subgroup'
            // ? {
            //     ...h,
            //     // ...toSelectionColProps(windSubgroupName),
            //     dataGetter: ({ rowData, header }) => {
            //       header.choices = windUtilitySubgroup[
            //         rowData.utility
            //       ].map(id => ({ text: windSubgroupName[id], value: id }))
            //       // .map(id => ({ [id]: windSubgroupName[id] }))
            //       // .reduce((a, b) => ({ ...a, ...b }))
            //       header.dataFormatter = ({ rowData, value }) =>
            //         windSubgroupName[rowData.subgroup] || value
            //       // rowData.subgroup

            //       return (
            //         windSubgroupName[parseInt(rowData.subgroup)] ||
            //         rowData.subgroup
            //       )
            //       // ||                   rowData.subgroup
            //     },
            //   }
            h
      ),
    [tagType, windUtilityName]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <table
      style={{
        width: '100%',
        borderSpacing: '10px',
        borderCollapse: 'inherit',
      }}
    >
      <tbody>
        <tr>
          <td>Date</td>
          <td>
            <DatePicker
              placeholder="Effeective Date"
              style={{ width: '200px' }}
              allowClear={false}
              format="MM/DD/YYYY"
              value={insertData.date}
              onChange={d => {
                setInsertData({
                  ...insertData,
                  date: d,
                  effectieveDate: d.format('YYYY-MM-DD'),
                })
              }}
            />
          </td>
          <td>PI Tag</td>
          <td>
            <Input
              style={{ width: '200px' }}
              value={insertData.piTag}
              onChange={e =>
                setInsertData({ ...insertData, piTag: e.target.value })
              }
            />
          </td>
          <td>Type</td>
          <td>
            <Select
              style={{ width: '200px' }}
              value={insertData.tagType}
              onChange={v => setInsertData({ ...insertData, tagType: v })}
            >
              {Object.keys(tagType).map(k => (
                <Select.Option key={k} value={k}>
                  {k}
                </Select.Option>
              ))}
            </Select>
          </td>
          <td>Is Active</td>
          <td>
            <Select
              style={{ width: '80%' }}
              value={insertData.isActive}
              onChange={c => setInsertData({ ...insertData, isActive: c })}
            >
              <Select.Option key="Y" value="Y">
                Yes
              </Select.Option>
              <Select.Option key="N" value="N">
                No
              </Select.Option>
            </Select>
          </td>
        </tr>
        <tr>
          <td>Utility</td>
          <td>
            <Select
              style={{ width: '200px' }}
              value={insertData.utility}
              onChange={v =>
                setInsertData({ ...insertData, utility: v, subgroup: null })
              }
            >
              {Object.keys(windUtilityName).map(k => (
                <Select.Option key={k} value={k}>
                  {k}- {windUtilityName[k]}
                </Select.Option>
              ))}
            </Select>
          </td>
          <td>Subgroup</td>
          <td>
            <Input
              style={{ width: '200px' }}
              value={insertData.subgroup}
              onChange={e =>
                setInsertData({ ...insertData, subgroup: e.target.value })
              }
            />
            {/* <Select
              style={{ width: '200px' }}
              value={insertData.subgroup}
              onChange={v =>
                setInsertData({
                  ...insertData,
                  subgroup: v,
                  utility: insertData.utility,
                })
              }
            >
              {(windUtilitySubgroup[insertData.utility] || []).map(id => (
                <Select.Option key={id} value={id}>
                  {windSubgroupName[parseInt(id)]}
                </Select.Option>
              ))}
            </Select> */}
          </td>
          <td>Multiplier</td>
          <td>
            <InputNumber
              style={{ width: '200px' }}
              value={insertData.multiplier}
              onChange={value =>
                setInsertData({ ...insertData, multiplier: value })
              }
            />
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(false)}>
              Add & Hide
            </Button>
          </td>
          <td>
            <Button type="danger" onClick={onCancel}>
              Cancel
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  )

  return [
    <CommonScreen
      title={title}
      header={headerformatter}
      saveTask={modifyTask}
      retrieveTask={getPiTags}
      withDatePicker
      withCriteria={(state, props, selectedUnits, selectedDate) => selectedDate}
      withUnitSelection={false}
      deleteTask={deleteTask}
      // autoRetrieve={false}
      altBy={d => d.piTag}
      // sortOptions={[utilityHeader, unitHeader]}
      insertComp={insertEvent && hasPITagWriteAccess && insertComp}
      insertCompHeight={250}
      onInsertEvent={b => setInsertEvent(b && hasPITagWriteAccess)}
      headerRowHeight={30}
      defaultInsertData={{ isActive: 'Y', isFiveMinute: 'N' }}
      heightOffset={insertEvent ? 330 : 220}
      isAdminScreen={false}
      withoutModify={!hasPITagWriteAccess}
      allowInsert={hasPITagWriteAccess}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(PITag)
